import { useI18n } from "@/hooks/useI18n";
import "./sub.account.list.scss";
import { useMemo, useState, useEffect } from "react";
import { Flex, Image, Text, chakra, Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useMedia } from "@/hooks/useMedia";
import DeactivateAccountModal from "./DeactivateAccountModal";
import DelAccountModal from "./DelAccountModal";
import dayjs from "dayjs";
import EnableAccountModal from "./EnableAccountModal";
import {
  getSubAccountListApi,
  activateSubAccountApi,
  deleteSubAccountApi,
  deactivateSubAccountApi,
} from "@/api/subAccount";
import { toastTip } from "@/components/ui/toast";

const ItemText = chakra(Text, {
  baseStyle: {
    color: "#010313",
    fontSize: "14px",
  },
});

const StatusTag = chakra(Flex, {
  baseStyle: {
    alignItems: "center",
    borderRadius: "4px",
    justifyContent: "center",
    w: "max-content",
    fontSize: "12px",
    padding: "5px 10px",
    fontWeight: 500,
    "&.normal": {
      bgColor: "rgba(51, 59, 245, 0.1)",
      color: "#4B5DFF",
    },
    "&.deac": {
      bg: "#FCEDEF",
      color: "#D04457",
    },
  },
});

const MainText = chakra(Box, {
  baseStyle: {
    fontSize: "14px",
    color: "#333BF5",
    _hover: {
      textDecoration: "underline",
    },
  },
});

const DeacText = chakra(Box, {
  baseStyle: {
    fontSize: "14px",
    color: "#D04457",
    _hover: {
      textDecoration: "underline",
    },
  },
});

const OperateWrap = chakra(Flex, {
  baseStyle: {
    width: "100%",
    gap: "10px",
    padding: "0px 20px",
    justifyContent: "center",
  },
});

const STATUS_MAPS = {
  NORMAL: "NORMAL",
  DEACTIVATE: "DEACTIVATE",
};
const SubAccountList = ({ setAccountLen }) => {
  const { t } = useI18n();
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  const { isMobile } = useMedia();
  const [showDeacModal, setShowDeacModal] = useState(false); // 停用
  const [showDelModal, setShowDelModal] = useState(false); // 删除
  const [showEnableModal, setEnableModal] = useState(false); // 启用
  const [itemInfo, setItemInfo] = useState();

  useEffect(() => {
    getSubAccountListFunc();
  }, []);

  const getSubAccountListFunc = async () => {
    const res = await getSubAccountListApi();
    if (res.code === 0) {
      setListData(res.data.sub_users);
      setAccountLen(res?.data?.sub_users?.length || 0);
    }
  };

  const deactivateSubAccountFunc = async () => {
    if (!itemInfo) return;
    const { target_id } = itemInfo;
    const res = await deactivateSubAccountApi({ target_id });
    if (res.code === 0 && res?.data?.ok) {
      toastTip(t("biXQrrlOVDoExCZZKC"), { type: "success" });
      setShowDeacModal(false);
      getSubAccountListFunc();
    }
  };

  const deleteSubAccountFunc = async () => {
    if (!itemInfo) return;
    const { target_id } = itemInfo;
    const res = await deleteSubAccountApi({ target_id });
    if (res.code === 0 && res?.data?.ok) {
      toastTip(t("UKenwEAFyRZgQyZTmPYy"), { type: "success" });
      setShowDelModal(false);
      getSubAccountListFunc();
    }
  };

  const activateSubAccountFunc = async () => {
    if (!itemInfo) return;
    const { target_id } = itemInfo;
    const res = await activateSubAccountApi({ target_id });
    if (res.code === 0 && res?.data?.ok) {
      toastTip(t("biXQrrlOVDoExCZZKC"), { type: "success" });
      setEnableModal(false);
      getSubAccountListFunc();
    }
  };

  const memoTexts = useMemo(() => {
    return [
      t("YbTVKYSCHSNbVSRpbwRM"),
      "UID",
      t("wQEsyNYfqlFrkqUvaDx"),
      t("rWOqJloUMhKXCZHLpnc"),
      t("rbefbFgPVyawmaktVYF"),
    ];
  }, [t]);

  const renderOperateMain = (item) => {
    const { status, uid } = item;
    return (
      <OperateWrap>
        {status === STATUS_MAPS.NORMAL && (
          <MainText
            onClick={() =>
              navigate(`/trade/subAccount/transfer?accountId=${uid}`)
            }
          >
            {t("tjsCbqUvgNvcdRqdDp")}
          </MainText>
        )}
        {status === STATUS_MAPS.NORMAL && (
          <DeacText
            onClick={() => {
              setItemInfo(item);
              setShowDeacModal(true);
            }}
          >
            {t("ZtmHIANowsUTyUyouyg")}
          </DeacText>
        )}
        {status === STATUS_MAPS.DEACTIVATE && (
          <MainText
            onClick={() => {
              setItemInfo(item);
              setEnableModal(true);
            }}
          >
            {t("DyXvKDfsUBPKtQScEVw")}
          </MainText>
        )}
        <Image
          cursor={"pointer"}
          src="../../wwwsite/images/whitelist/trash2.svg"
          w={"24px"}
          h={"24px"}
          onClick={() => {
            setItemInfo(item);
            setShowDelModal(true);
          }}
        />
      </OperateWrap>
    );
  };

  return (
    <>
      <div
        className="sub-account-list"
        style={{ minHeight: listData.length === 0 ? "200px" : "0px" }}
      >
        <div className="header">
          {memoTexts.map((d, i) => {
            return (
              <Text fontSize={"14px"} color={"#7B7C8F"} key={i}>
                {d}
              </Text>
            );
          })}
        </div>
        <div className="body">
          {listData.map((item) => {
            return (
              <Flex
                fontSize={"14px"}
                color={"#7B7C8F"}
                _hover={{
                  cursor: "pointer",
                  backgroundColor: "rgba(32, 26, 85, 0.05) !important",
                }}
                key={item.uid}
                className="row"
              >
                <ItemText>{item.email}</ItemText>
                <ItemText>{item.uid}</ItemText>
                <ItemText>
                  {item.status === STATUS_MAPS.NORMAL ? (
                    <StatusTag className="normal">
                      {t("uPEmuahfZCJKifAf")}
                    </StatusTag>
                  ) : (
                    <StatusTag className="deac">
                      {t("NazoeCHUJpEyQWZDKcVt")}
                    </StatusTag>
                  )}
                </ItemText>

                <ItemText>
                  {dayjs(Number(item.register_time) * 1000).format(
                    "YYYY-MM-DD HH:mm"
                  )}
                </ItemText>
                <Flex
                  gap={"15px"}
                  backgroundColor={isMobile ? "#fff" : ""}
                  className="last"
                >
                  {renderOperateMain(item)}
                </Flex>
              </Flex>
            );
          })}
          {!listData.length && (
            <Text color={"#010313"} fontSize={"14px"} className="no-data">
              {t("nmuzQLDdidsSBtDTLaU")}
            </Text>
          )}
        </div>
      </div>
      {/* 停用 */}
      <DeactivateAccountModal
        show={showDeacModal}
        onOK={() => deactivateSubAccountFunc()}
        onCancel={() => setShowDeacModal(false)}
        itemInfo={itemInfo}
      />
      {/* 删除 */}
      <DelAccountModal
        show={showDelModal}
        onOK={() => deleteSubAccountFunc()}
        onCancel={() => setShowDelModal(false)}
      ></DelAccountModal>
      {/* 启用 */}
      <EnableAccountModal
        show={showEnableModal}
        onOK={() => activateSubAccountFunc()}
        onCancel={() => setEnableModal(false)}
      ></EnableAccountModal>
    </>
  );
};

export default SubAccountList;
